













import { ValidationProvider } from 'vee-validate';
import { Vue, Component, VModel, Prop } from 'vue-property-decorator';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class VTextFieldWithValidation extends Vue {
  @VModel()
  public innerValue: any;

  @Prop({ type: [String, Object], default: '' })
  public readonly rules!: string | Object;
}
